import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin: 1rem;
`

export const CustomButton = styled(ButtonMui)`
  width: 25%;    
  height: 2.5rem !important;
  margin: .4rem !important;
`
